// DinamicTable.tsx
import React, { useMemo } from "react";
import { Grid, IconButton, Tooltip } from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import type { DinamicTableProps } from "./types";
import { useDinamicTable } from "./useDinamicTable";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";

const DinamicTable: React.FC<DinamicTableProps> = (props) => {
  const { darkMode, handleFiltro, data, buildMDColumns } = useDinamicTable(props);

  const tableData = useMemo(() => buildMDColumns(), [data]);

  return (
    <Grid container direction="row">
      {props?.titulo && (
        <Grid item xs={12} style={{ padding: "12px" }}>
          <h3 style={darkMode ? { color: "white" } : { color: "#344767" }}>{props.titulo}</h3>
        </Grid>
      )}

      <Grid container direction="row-reverse" alignItems="center">
        {!props?.sinExport && (
          <Grid item xs={12} md={2} style={{ textAlign: "center", padding: "12px" }}>
            <Tooltip title="Exportar a excel">
              <IconButton
                disabled={!tableData.rows?.length}
                size="small"
                style={{
                  color: darkMode ? "#4CAF50" : "#fff",
                  backgroundColor: darkMode ? "#fff" : "#4CAF50",
                  borderRadius: "5px",
                  width: "100%",
                }}
              >
                <SimCardDownloadIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        )}
      </Grid>

      <Grid item xs={12} style={{ padding: "12px" }}>
        <DataTable
          table={tableData}
          canSearch={props.canSearch ?? false}
          showTotalEntries
          isSorted
          entriesPerPage={{ defaultValue: 10, entries: [5, 10, 25, 50] }}
          pagination={{ variant: "gradient", color: "info" }}
        />
      </Grid>
    </Grid>
  );
};

export default DinamicTable;
